import type { ExcelDownloadClient } from "app/components/React/ExcelButton/ExcelClientDownload";
import type { IFetchService } from "app/services/fetchService";

import { createAppsApiService } from "./appsApiService";
import { createCompaniesApiService } from "./companiesApiService";
import { createWebsitesApiService } from "./websitesApiService";

/**
 * Service for all "leads"-based endpoints
 */
const createAdvancedSearchPageApiService = (fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) => {
    return {
        apps: createAppsApiService(fetchService, excelDownloadClient),
        companies: createCompaniesApiService(fetchService, excelDownloadClient),
        websites: createWebsitesApiService(fetchService, excelDownloadClient),
    };
};

export default createAdvancedSearchPageApiService;
